module.exports = __webpack_public_path__ + "img/freelancer-item-2.2bbffff3.png";